import { GatekeeperOAuthClient } from "./gatekeeper-oauth-client";
import type {
  StoreGatekeeperOAuthState,
  GatekeeperOAuthCallbackHandler,
} from "./gatekeeper-oauth-client";
import api from "./api";

const GATEKEEPER_BASE_URL = process.env.REACT_APP_GATEKEEPER_BASE_URL;
const GATEKEEPER_OAUTH_CLIENT_ID =
  process.env.REACT_APP_GATEKEEPER_OAUTH_CLIENT_ID;

/**
 * Create OAuth client instance for current organization context
 */
const createOAuthClient = (): GatekeeperOAuthClient => {
  if (!GATEKEEPER_OAUTH_CLIENT_ID || !GATEKEEPER_BASE_URL) {
    throw new Error(
      "Gatekeeper OAuth not configured. Set REACT_APP_GATEKEEPER_OAUTH_CLIENT_ID and REACT_APP_GATEKEEPER_BASE_URL"
    );
  }

  const { protocol, host, pathname } = window.location;
  const orgSlug = pathname.split("/")[2]; // Extract from /organization/{slug}/...

  return new GatekeeperOAuthClient({
    clientId: GATEKEEPER_OAUTH_CLIENT_ID,
    redirectUri: `${protocol}//${host}/organization/${orgSlug}/oauth-gatekeeper-callback`,
  });
};

/**
 * Store OAuth state via acquire-api
 */
export const storeGatekeeperOAuthState: StoreGatekeeperOAuthState = async (
  params
) => api.post("/auth/oauth/state", params);

/**
 * Handle Gatekeeper OAuth callback and exchange code for tokens
 * Note: This should be called from a thunk that has access to Redux state
 */
export const createHandleGatekeeperOAuthCallback = (
  organizationId: number
): GatekeeperOAuthCallbackHandler => {
  return async (params) => {
    const { data } = await api.post(
      `/organizations/${organizationId}/oauth/gatekeeper/callback`,
      params
    );
    return data.token;
  };
};

/**
 * Lazy OAuth client getter - only creates client when needed
 * This allows the app to work without OAuth configured (for native login)
 */
let _oAuthClient: GatekeeperOAuthClient | null = null;

export const getOAuthClient = (): GatekeeperOAuthClient => {
  if (!_oAuthClient) {
    _oAuthClient = createOAuthClient();
  }
  return _oAuthClient;
};
